"use client";
import classes from "./index.module.css";
import { PropsWithChildren, useEffect, useRef } from "react";
import { useMediaQuery } from "@mantine/hooks";
import { Modal, Title, useMantineTheme } from "@mantine/core";
import textClasses from "../Text/Text.module.css";
import { pushModalOpen, pushModalClose } from "@/utils/dataLayer";
import { consumeModalClose, markModalClose } from "@/utils/modalClose";

export const ModalTitle = ({ children }: PropsWithChildren) => {
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
  const titleRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    const modalName = titleRef.current?.textContent?.trim();
    if (!modalName) {
      return;
    }
    // Reset on open so a stale close tag (e.g. an Escape press that didn't close
    // a modal) can't carry over to this modal's close event.
    markModalClose({});
    pushModalOpen(modalName);
    return () => {
      const { modalButton, modalCloseType } = consumeModalClose();
      pushModalClose(modalName, modalButton, modalCloseType);
    };
  }, []);

  return (
    <Modal.Title ref={titleRef} className={classes.title}>
      <Title fw={900} lts={0} component="span" className={isMobile ? textClasses.h4 : textClasses.h2}>
        {children}
      </Title>
    </Modal.Title>
  );
};
